<template>
    <div>
        <info-popover v-if="showContinueBtn" :content="continueBtnDisabledExplanation" placement="top">
            <session-button
                @click="handleContinueClick()"
                :loading="continueIsLoading"
                class="btn-brand"
                :class="{ disabled: !continueBtnEnabled }"
                :disabled="continueIsLoading"
                ref="continueBtn"
            >
                {{ continueBtnText }}
            </session-button>
        </info-popover>
        <info-popover v-else-if="showSubmitBtn" :content="submitBtnDisabledExplanation" placement="top">
            <session-button
                @click="handleSubmitClick()"
                :loading="submitIsLoading"
                class="btn-brand"
                :class="{ disabled: !submitBtnEnabled }"
                :disabled="submitIsLoading"
                ref="continueBtn"
            >
                {{ submitBtnLabel }}
            </session-button>
        </info-popover>
    </div>
</template>

<script>
import InfoPopover from "@/components/InfoPopover"
import SessionButton from "@/components/SessionButton"

export default {
    name: "SessionFooterBtns",
    components: {
        InfoPopover,
        SessionButton,
    },
    data() {
        return {}
    },
    computed: {
        continueBtnText() {
            return this.$store.getters.continueBtnText
        },
        continueIsLoading() {
            return this.$store.getters.continueIsLoading
        },
        continueBtnEnabled() {
            return this.$store.getters.continueIsEnabled
        },
        showContinueBtn() {
            return this.$store.getters.showContinueBtn
        },
        continueBtnDisabledExplanation() {
            return this.$store.getters.continueBtnDisabledExplanation
        },
        submitBtnLabel() {
            return this.$store.getters.submitBtnLabel
        },
        submitIsLoading() {
            return this.$store.getters.submitIsLoading
        },
        submitBtnEnabled() {
            return this.$store.getters.submitIsEnabled
        },
        showSubmitBtn() {
            return this.$store.getters.showSubmitBtn
        },
        submitBtnDisabledExplanation() {
            return this.$store.getters.submitBtnDisabledExplanation
        },
        currentNodeId() {
            return this.$store.getters.sessionCurrentNodeId
        },
    },
    methods: {
        handleContinueClick() {
            // Handle the disabled state here because setting the disabled attribute directly
            // on the button via html blocks click events on the element, which are used to
            // show popover messages over the button on mobile.
            if (!this.continueBtnEnabled) {
                return
            }
            this.$emit("continue")
        },
        handleSubmitClick() {
            if (!this.submitBtnEnabled) {
                return
            }
            this.$emit("submit")
        },
    },
}
</script>

<style>
</style>